import React, { useEffect, useState } from "react";
import Clm2Img from "../assets/Icons/mail.svg";
import Clm1Img from "../assets/Icons/phone.svg";
import ogimage from "../assets/Images/ogImages/contactus@2x.png";
import BannerBgImage from "../assets/Images/ContactUs/ContactUS-Banner.png";
import BackArrowIcon from "../assets/Images/accordian.svg";
import Typography from "@material-ui/core/Typography";
import Button from "../components/Button";

import ImageBanner from "../templates/ImageBanner";

import Layout from "../components/layouts/layout";
import { BASE_SITE_URL } from "../shared/constants";
import ContactUsComponent from "../templates/ContactUs";
//Two column contact info
import TwoColumnContactInfo from "../templates/TwoColumnContactInfo";

const ContactUs = ({ location }) => {
  const [selectName, setSelectName] = useState(null);
  const [selectType, setSelectType] = useState(null);
  useEffect(() => {
    // document.getElementById("header").classList.add("toolbar_onscroll_article");
  });
  // Function to decode URL query parameters
  function decodeQueryParams(search) {
    if (!search) return { type: null, name: null };

    const params = new URLSearchParams(search);
    const type = params.get("type")
      ? decodeURIComponent(params.get("type"))
      : null;
    const name = params.get("name")
      ? decodeURIComponent(params.get("name"))
      : null;

    return { type, name };
  }

  useEffect(() => {
    if (location.search) {
      const { type, name } = decodeQueryParams(location.search);
      setSelectType(type);
      setSelectName(name);
    }
  }, [location.search]);


  const TwoColumnContactInfoData = {
    Clm1Img: Clm1Img,
    Clm1Title: "Phone:",
    Clm1SubTitle: "+44 (0) 161 706 7983",
    Clm2Img: Clm2Img,
    Clm2Title: "Email:",
    Clm2SubTitle: "hello@digiryte.com",
  };
  const ImageBannerData = {
    bnrImg: BannerBgImage,
    altImg: BannerBgImage,
    component: "Who",
    bnrImgTitle: "Contact Us",
  };
  return (
    <Layout
      seo={{
        title: "Contact Digiryte | Speak to a Technology Consultant",
        ogtitle: "Contact Digiryte | Speak to a Technology Consultant",
        description:
          "Discuss your software, AI, cloud or technology audit needs with Digiryte. Contact our UK team to plan the right next step.",
        ogimage: ogimage,
        ogurl: `${BASE_SITE_URL}/contact-us/`,
      }}
    >
      <ImageBanner imageBannerData={ImageBannerData} />
      <div className="body-container">
        <Button
          icon={
            <img
              className="effect-btn-svgicon"
              src={BackArrowIcon}
              alt="click"
            />
          }
          customClassName="effect-btn"
          className="mui-button-font"
          tip="Home"
          routepath="/"
        />
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "-42px",
            marginLeft: "40px",
          }}
        >
          Home
        </Typography>
      </div>
      <div className="mt-50 body-container">
        <div className="contact-us-title-header">
          How can we help you today?
        </div>
        <div style={{ width: "125px" }} className="red-line"></div>
      </div>
      <div className="">
        <ContactUsComponent name={selectName} type={selectType} />
      </div>
      
      <div className="mt-50">
        <TwoColumnContactInfo
          TwoColumnContactInfoData={TwoColumnContactInfoData}
        />
      </div>
    </Layout>
  );
};

export default ContactUs;
